import Component from "@glimmer/component";
import { service } from "@ember/service";
import type AudioService from "#services/audio.ts";
import { on } from "@ember/modifier";
import { fn } from "@ember/helper";
import { Sound } from "#models/sound.ts";
import { pageTitle } from "ember-page-title";
import AudioVisualizer from "#components/audio-visualizer.gts";

export default class SoundsTemplateComponent extends Component {
  @service declare audio: AudioService;

  sounds = Sound.all;

  playSound = (sound: Sound) => {
    this.audio.playSound(sound);
  };

  <template>
    {{pageTitle "Sounds"}}

    {{#if this.audio.isLoaded}}
      <div class="flex flex-col gap-6 max-w-5xl mx-auto p-4">
        <AudioVisualizer @mode={{1}} class="h-32" />

        <ul class="flex flex-wrap gap-6">
          {{#each this.sounds as |sound|}}
            <li class="flex flex-col w-56">
              <button
                type="button"
                {{on "click" (fn this.playSound sound)}}
                class="{{sound.colorClass}}
                  border-2 border-black px-4 py-2 text-white font-bold rounded shadow transition-transform active:scale-95"
              >
                {{sound.name}}
              </button>
              <div class="text-xs pl-3">
                <div>id: <span class="font-mono">{{sound.id}}</span></div>
                <div>offset: <span class="font-mono">{{sound.offset}}</span></div>
                <div>duration:
                  <span class="font-mono">{{sound.duration}}</span></div>
              </div>
            </li>
          {{/each}}
        </ul>
      </div>
    {{/if}}
  </template>
}
